module.exports = __webpack_public_path__ + "img/may_460.d1ed7246.png";